import React, { FC, ReactNode } from 'react';
import InfoTooltip from '@uikit/Info/InfoTooltip/InfoTooltip';
import { newInfoType } from '@src/types';

type SectionTitleProps = {
  info?: newInfoType;
  title: string | undefined;
  className?: string;
  children?: ReactNode;
  dataTestId?: string;
  isHeightNeeded?: boolean;
};

const SectionTitle: FC<SectionTitleProps> = ({
  info,
  title,
  className,
  children,
  dataTestId,
  isHeightNeeded,
}) => {
  return (
    <div
      className={`section-title ${className ? className : ''}`}
      data-test-id={dataTestId}
      style={{ height: isHeightNeeded ? '30px' : 'auto' }}
    >
      {title && (
        <div className="title_wrapper">
          <h2>{title}</h2>
          {info?.toggle && info?.desc && (
            <InfoTooltip title={info?.desc} placement="left-end" />
          )}
        </div>
      )}
      {children}
    </div>
  );
};

export default SectionTitle;
